export enum ANOBIS_MIS_GROUP_LEVEL {
    ANOBIS_MIS_GROUP_LEVEL_POC = "ANOBIS_MIS_GROUP_LEVEL_POC",
    ANOBIS_MIS_GROUP_LEVEL_L1 = "ANOBIS_MIS_GROUP_LEVEL_L1",
    ANOBIS_MIS_GROUP_LEVEL_L2 = "ANOBIS_MIS_GROUP_LEVEL_L2",
}

export const getAnobisMisGroupLevel = (misRole: string | null | undefined) => {
    if (!misRole) {
        return null;
    }
    if (misRole.includes(ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_POC)) {
        return ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_POC;
    }
    if (misRole.includes(ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L1)) {
        return ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L1;
    }
    if (misRole.includes(ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L2)) {
        return ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L2;
    }
    return null;
}

export const isPoc = (misRole: string | null | undefined) => {
    return getAnobisMisGroupLevel(misRole) === ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_POC;
}

export const isL1 = (misRole: string | null | undefined) => {
    return getAnobisMisGroupLevel(misRole) === ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L1;
}

export const isL2 = (misRole: string | null | undefined) => {
    return getAnobisMisGroupLevel(misRole) === ANOBIS_MIS_GROUP_LEVEL.ANOBIS_MIS_GROUP_LEVEL_L2;
}

